import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Órdenes de compra" },
  { label: "PO", icon: "fas fa-shopping-basket", color: "#10b981", bg: "#f0fdf4", href: "/ListadoOrdenesCompra", desc: "Órdenes de compra a proveedor", perm: "menu_oc" },
  // { label: "Pendiente Embarcar", icon: "fas fa-plane-departure", color: "#3b82f6", bg: "#eff6ff", href: "/ListadoPendEmbarcar", desc: "OC pendientes de embarcar", perm: "pendiente_embarcar" },  // se embarca desde la orden
  { type: "section", label: "Seguimiento de producción" },
  { label: "Tracking Mexico", icon: "fas fa-clipboard-check", color: "#0ea5e9", bg: "#f0f9ff", href: "/SeguimientoMX", desc: "Checklist de OC: etiquetas, ficha, GS1, FOB", perm: "menu_procesos" },
  { label: "Tracking China", icon: "fas fa-globe-asia", color: "#f43f5e", bg: "#fff1f2", href: "/SeguimientoChina", desc: "Checklist por modelo: muestras, tags, contenedor", perm: "menu_procesos" },
  { type: "section", label: "Embarques" },
  { label: "Embarques", icon: "fas fa-ship", color: "#8b5cf6", bg: "#f5f3ff", href: "/ListadoEmbarques", desc: "Contenedores y embarques", perm: "embarques" },
  // { label: "Embarques Directos", icon: "fas fa-ship", color: "#0ea5e9", bg: "#f0f9ff", href: "/EmbarquesDirectosCreate", desc: "Embarque sin OC previa", perm: "menu_compras" },
  // { label: "Pendiente Recibir", icon: "fas fa-plane-arrival", color: "#f43f5e", bg: "#fff1f2", href: "/ListadoPendRecibir", desc: "Embarques pendientes de recibir", perm: "pendiente_recibir" },  // se recibe desde el embarque
  { type: "section", label: "Recepción" },
  { label: "Entradas", icon: "fas fa-cart-plus", color: "#14b8a6", bg: "#f0fdfa", href: "/ListadoCompras", desc: "Recepción de mercancía", perm: "menu_compras" },
  { label: "Compras Directas", icon: "fas fa-cart-plus", color: "#f59e0b", bg: "#fffbeb", href: "/ComprasDirectasCreate", desc: "Compra sin OC previa", perm: "menu_compras" },
  { label: "Reporte Compras", icon: "fas fa-shopping-cart", color: "#3b82f6", bg: "#eff6ff", href: "/ReporteCompras", desc: "Reporte de compras", perm: "menuCalidad" },
  { type: "section", label: "Maquilas" },
  { label: "Salida a Maquila", icon: "fas fa-sign-out-alt", color: "#f59e0b", bg: "#fffbeb", href: "/ListadoProcesosSalida", desc: "Envio de piezas al maquilero", perm: "menu_procesos" },
  { label: "Entrada de Maquila", icon: "fas fa-sign-in-alt", color: "#10b981", bg: "#f0fdf4", href: "/ListadoProcesosEntrada", desc: "Recepcion de piezas maquiladas", perm: "menu_procesos" },
];

function BotonesCompras() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-shopping-cart" color="#f59e0b" bg="#fffbeb" title="Compras e Importación" subtitle="Órdenes de compra, embarques y recepción" />
        {user.menu_compras ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesCompras;
